module.exports = __webpack_public_path__ + "static/media/login.6a819ed7.png";